import { ANALYTICS_DESTINATIONS } from "./analytics-destinations";

export const ANALYTICS_REPORT_PAGES = [
  "/admin/analytics", "/admin/analytics/customers", "/admin/analytics/demand",
  "/admin/analytics/sales", "/admin/analytics/operations", "/admin/ads",
] as const;

export function analyticsReportPage(href: string): string | undefined {
  if (href.split(/[?#]/)[0] !== "/admin/analytics") return undefined;
  const view = analyticsReportView(href);
  const destination = ANALYTICS_DESTINATIONS.find((entry) => entry.section === view);
  if (destination) return destination.permission;
  if (view === "customers") return "/admin/analytics/customers";
  if (["acquisition", "demand", "ads", "leads", "quotes"].includes(view ?? "")) return "/admin/analytics/demand";
  if (["operations", "products", "shipping", "cash-conversion"].includes(view ?? "")) return "/admin/analytics/operations";
  if (view === "sales") return "/admin/analytics/sales";
  return view ? "/admin/analytics" : undefined;
}

export function analyticsReportView(href: string) {
  const query = new URLSearchParams(href.split("?")[1]?.split("#")[0]);
  return query.get("view") ?? query.get("section") ?? query.get("tab");
}
